module.exports = ":host .nav-link {\n  line-height: 2; }\n  @media (max-width: 1024px) {\n    :host .nav-link {\n      line-height: 1.5; } }\n  :host .nav-link .navbar-brand {\n    font-size: 0.875rem;\n    margin-right: 0px; }\n  :host .nav-link .wrapp-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 355px;\n    vertical-align: bottom; }\n  :host .dropdown-item {\n  font-size: 0.875rem; }\n  :host .width100 {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dropdown-menu/dropdown-menu.component.scss
// module id = ./src/app/shared/components/dropdown-menu/dropdown-menu.component.scss
// module chunks = main